import util from "@/assets/js/common/util";
import softUtil from "@/assets/js/service/softUtil";
import {
  getAfterAlbumList,
  getAiKxDocumentList,
  getAlbumList,
  getCatalogWordList,
  getDocumentList,
  getLhsDocumentList,
  getMaterialNodeKnowledgeDocumentList,
  getSchoolBasedList,
  getZykDocumentList,
} from "@/utils/apis";
import Cookie from "js-cookie";
let isRouteQueryReset = true;
// 使用范围
const USESCOPE = "USESCOPE";
let stop = null;
function handleFirstUseScope() {
  // debugger;
  let useScope = Cookie.get(USESCOPE);
  if (useScope) {
    let useScopeArr = useScope.split("|");
    let [year, term, grade] = useScopeArr;

    return {
      year,
      term,
      grade,
    };
  } else {
    return {
      year: "",
      term: "",
      grade: "",
    };
  }
}
export default {
  data() {
    return {
      // 资料类别
      softTypes: util.softTypes,
      // 当前资料类别
      currentSoftType: 1,
      // 是否正在加载资源列表
      isLoading: false,
      // 资料列表
      documentList: [],
      // 每页显示条数
      // pageSize: util.pageSize,
      // 当前页码
      pageIndex: 1,
      // 资料总数
      documentCount: 0,
      // 总页数
      totalPages: 0,
      // 显示预览弹框
      showPreviewDialog: false,
      // 当前预览资料id
      currentPreviewSoftId: 28774989,
      // 搜索词
      keywords: "",
      // 返回结果中的关键词
      keyArray: [],
      // 分页每页显示条数 的列表
      pageSizes: util.pageSizes,
      knowledgeRecommendIndex: 0,
      hasKnowledgeRecommend: false,
    };
  },
  mounted() {
    // console.log("resource mounted");
    let path = this.$route.path;
    let notLabAndSci = path.indexOf("/lab") == -1 && path.indexOf("/sci") == -1;
    // console.log("notLabAndSci", notLabAndSci);
    notLabAndSci ? (this.pageSize = util.pageSize) : null;
  },
  methods: {
    // 判断当前页面 一页多少条
    judgeCurrentPageSize() {
      // console.log("judgeCurrentPageSize");
      // max-width: 1300px  每行3条
      // (max-width: 1750px) and (min-width: 1301px) 每行四条
      // and (max-width: 1920px) and (min-width: 1751px) 每行五条
      // @media screen and (min-width: 1921px)  每行六条
      var pageWidth =
        window.innerWidth ||
        document.documentElement.clientWidth ||
        document.body.clientWidth;
      // console.log("pageWidth", pageWidth);
      if (pageWidth <= 1300) {
        this.pageSize = 15;
      } else if (pageWidth > 1301 && pageWidth <= 1920) {
        this.pageSize = 20;
      } else {
        this.pageSize = 24;
      }
      console.log("pageSize", this.pageSize);
    },
    handleDownload(id) {
      softUtil.WriteDownScript(id, this);
    },
    //下载校本资源
    handleDownloadSchoolBased(id) {
      softUtil.WriteDownScriptSchoolBased(id.resourceId, this);
    },
    // 每页显示的数量改变
    pageSizeChange(val) {
      this.pageIndex = 1;
      this.updateQuery({ pageSize: val, pageIndex: 1 });
      this.pageSize = val;
    },
    // 翻页功能
    pageIndexChange(val) {
      this.updateQuery({ pageIndex: val, pageSize: this.pageSize });
      this.pageIndex = val;
    },
    //
    async getCatalogWordList() {
      this.totalPages = 0;
      this.totalCount = 0;
      this.isLoading = true;
      let { parentCatalogIds, textbookId, pageIndex, pageSize } =
        this.$route.query;
      let { result } = await getCatalogWordList({
        catalogId: parentCatalogIds,
        textBookId: textbookId,
        pageIndex,
        pageSize,
      });
      this.isLoading = false;
      this.documentList = result.list || [];
      this.documentCount = result.totalCount || 0;
      this.totalPages = result.totalPages || 0;
      this.totalCount = result.totalCount || 0;
      // console.log('result',result)
    },
    // 获取文档列表
    async getDocumentList(
      isSchoolBased,
      isMaterialType = false,
      pageIndex = 1
    ) {
      console.log("getDocumentList", isSchoolBased, isMaterialType, pageIndex);
      // debugger;
      if (stop) {
        stop();
      }
      // debugger
      let status = {
        clear: false,
      };
      stop = () => {
        status.clear = true;
      };
      let path = this.$route.path;
      let isLab = path.indexOf("/lab") > -1;
      let isTech = path.indexOf("/tech") > -1;
      let isZyk = path.indexOf("/zyk") > -1;
      let isSci = path.indexOf("/sci") > -1;
      // console.log("调用接口");
      // 是否是阅读页面
      // let isRead = path.indexOf('/read') > -1;
      this.isLoading = true;
      let query = this.$route.query;
      let includeQuery = [
        "stageId",
        "subjectId",
        "courseId",
        "pageIndex",
        "pageSize",
        "softType",
        "parentCatalogIds",
        "tabId",
        "textbookId",
      ];
      // console.log("route", this.$route);
      query = JSON.parse(JSON.stringify(query));
      // console.log("资料列表", query);
      if (!isMaterialType) {
        if (!query.pageIndex) {
          query.pageIndex = 1;
          // this.pageSize =  this.pageSize;
          query.pageSize = this.pageSize;
        }
      } else {
        query.pageIndex = pageIndex;
      }
      // 实操实验增加参数
      if (isLab) {
        query.experimentForm
          ? (query.experimentForm = query.experimentForm || "")
          : null;
      }
      // console.log("参数", query);
      let method = isLab
        ? getLhsDocumentList
        : isZyk
        ? getZykDocumentList
        : getDocumentList;
      method = isSci ? getAiKxDocumentList : method;
      // method = isRead ? getAiReadDocumentList : method;
      this.documentList = [];
      this.documentCount = 0;
      this.keyArray = [];
      try {
        let data = {};
        if (isSchoolBased) {
          let parentCatalogIds = query.parentCatalogIds;
          if (parentCatalogIds && typeof parentCatalogIds === "string") {
            query.parentCatalogIds = parentCatalogIds.split(",");
          }
          if (query.orders) {
            // query.orders = ["update_time$2"];
            query.orders = ["update_time$2"];
          }
          if (query.gradeIds) {
            if (typeof query.gradeIds === "string") {
              query.gradeIds = [query.gradeIds];
            }
          }
          if (query.textbookId) {
            query.textbookId = Number(query.textbookId);
          }
          if (query.parentScenarioKpoints) {
            query.parentScenarioKpoints = Number(query.parentScenarioKpoints);
          }
          // if(query.pulldowIdentification){
          //    query.pulldowIdentification = query.pulldowIdentification
          // }
          if (query.parentScenarioId) {
            query.parentScenarioIdV4 = query.parentScenarioId;
            delete query.parentScenarioId;
          }
          if (query.parentTypeIds) {
            query.parentTypeIdV4s = [query.parentTypeIds];
            delete query.parentTypeIds;
          }
          // if (!query.schoolYear && !query.term && !query.gradeIds) {
          //   let { year, term, grade } = handleFirstUseScope();
          //   year ? (query.schoolYear = year) : null;
          //   term ? (query.term = term) : null;
          //   grade ? (query.gradeIds = [grade]) : null;
          // }
          // console.log("query", query);
          data = await getSchoolBasedList(
            Object.assign(
              { ...query },
              query.title
                ? {
                    title: encodeURIComponent(query.title),
                  }
                : {}
            )
          );
        } else {
          // console.log("调用接口2");
          // if (query.orders === undefined) {
          //   // query.orders = "update_time$2";
          //   query.orders = "";
          // }
          // query.orders ?
          if (isSci) {
            query.pageId = query.pageId || 1;
          }

          // 去掉资料类型属性
          delete query.softType;
          if (!query.pageSize) return;
          data = await method(
            Object.assign(
              { ...query },
              query.title
                ? {
                    title: encodeURIComponent(query.title),
                  }
                : null,
              query.parentTypeId && (isZyk || isSci)
                ? {
                    parentTypeIdsV4: query.parentTypeId,
                  }
                : null,
              query.fileTypeId && isZyk
                ? {
                    fileTypeIds: query.fileTypeId,
                  }
                : null,
              query.parentScenarioId && isZyk
                ? {
                    parentScenarioIdsV4: query.parentScenarioId,
                  }
                : null,
              query.termId ? { term: query.termId } : null
              // query.orders ? { orders: [query.orders] } : null
            )
          );
        }
        // console.log("data", data, status);
        if (data.code === 200 && !status.clear) {
          if (!isMaterialType && this.currentSoftType === 1) {
            this.documentList = data.result.list || [];
            this.documentCount = data.result.totalCount || 0;
            this.totalPages = data.result.totalPages || 0;
            this.keyArray = data.result.keyWords || [];
            this.totalCount = data.result.totalCount || 0;
            this.documentMessage = data.result.message || "";
            // 如果是云资源并且tabId=1并且有目录id并且资料个数少于29条
            if (
              isTech &&
              query.tabId == 1 &&
              query.parentCatalogIds &&
              this.totalCount <= query.pageSize
            ) {
              let hasExcludeQuery = false;
              for (let key in query) {
                hasExcludeQuery = !includeQuery.includes(key);
                if (hasExcludeQuery) {
                  break;
                }
              }
              // 获取知识点推荐
              // console.log("获取知识点推荐");
              if (hasExcludeQuery) {
                this.isLoading = false;
              }
              !hasExcludeQuery && this.getMaterialNodeKnowledgeDocumentList();
            } else {
              this.isLoading = false;
              this.hasKnowledgeRecommend = false;
            }
          } else {
            this.isLoading = false;
            return data;
          }
        } else {
          this.isLoading = false;
        }
        this.isLoading = false;
      } catch (error) {
        console.error(error);
        this.isLoading = false;
      }
    },
    async getMaterialNodeKnowledgeDocumentList() {
      this.isLoading = true;
      let params = Object.assign({}, this.$route.query);
      let { result } = await getMaterialNodeKnowledgeDocumentList({
        ...params,
      });
      let pageIndex = params.pageIndex || 1;
      if (result) {
        let { list, totalCount, totalPages } = result;
        this.knowledgeRecommendIndex = this.documentList.length || 0;
        this.documentList =
          pageIndex == 1 ? this.documentList.concat(list) : list;
        this.totalPages = totalPages || 0;
        this.hasKnowledgeRecommend = totalCount > 0;
        this.totalCount = totalCount;
        this.documentCount = totalCount || 0;
      } else {
        this.hasKnowledgeRecommend = false;
      }
      this.isLoading = false;
    },
    // 获取专辑列表
    async getAlbumList(albumType) {
      this.isLoading = true;
      this.documentList = [];
      this.documentCount = 0;
      this.keyArray = [];
      // 处理请求参数
      let params = Object.assign({}, this.$route.query);
      // console.log("params------", this.$route.query);
      !params.pageIndex && (params.pageIndex = 1);
      if (params.orders) {
        params.orders = [params.orders];
      } else {
        params.orders = ["update_time$2"];
      }
      if (params.textbookId) {
        params.textbookIds = [params.textbookId];
        delete params.textbookId;
      }
      if (params.courseId) {
        params.courseIds = [params.courseId];
        delete params.courseId;
      }
      if (params.gradeIds) {
        params.gradeIds = [params.gradeIds];
      }
      if (params.subjectId) {
        params.subjectIds = [params.subjectId];
        delete params.subjectId;
      }
      if (params.stageId) {
        params.stageIds = [params.stageId];
        delete params.stageId;
      }
      if (params.parentTypeId) {
        params.parentTypeIds = [params.parentTypeId];
        delete params.parentTypeId;
      }
      if (params.parentAreaIds) {
        params.parentAreaIds = [params.parentAreaIds];
      }
      if (params.parentCatalogIds) {
        params.parentCatalogIds = [params.parentCatalogIds];
      }
      if (params.parentKPointId) {
        params.parentKPointIds = [params.parentKPointId];
        delete params.parentKPointId;
      }
      if (params.versionId) {
        params.versionIds = [params.versionId];
        // delete params.versionId;
      }
      if (params.parentScenarioId) {
        params.parentScenarioIds = [params.parentScenarioId];
        delete params.parentScenarioId;
      }
      if (params.title) {
        params.title = encodeURIComponent(params.title);
      }
      if (params.termId) {
        params.term = params.termId;
        delete params.termId;
      }
      if (params.parentScenarioKpoints) {
        params.parentScenarioKpoints = [Number(params.parentScenarioKpoints)];
      }
      // 是否是套卷类型
      if (albumType) {
        params.albumTypeIds = [albumType];
      }
      delete params.softType;
      try {
        // 资料列表
        // debugger
        let data = await getAlbumList({
          ...params,
        });
        // console.log("是否清除了", status);
        if (data.code === 200) {
          this.documentList = data.result.list || [];
          this.documentCount = data.result.totalCount || 0;
          this.totalPages = data.result.totalPages || 0;
          this.keyArray = data.result.keyWords || [];
          this.totalCount = data.result.totalCount || 0;
        }
      } catch (error) {
        console.error(error);
      }
      this.isLoading = false;
    },
    // 获取课后服务专辑列表
    async getAfterAlbumList(albumType) {
      this.isLoading = true;
      this.documentList = [];
      this.documentCount = 0;
      this.keyArray = [];
      // 处理请求参数
      let params = Object.assign({}, this.$route.query);
      !params.pageIndex && (params.pageIndex = 1);
      if (params.orders) {
        params.orders = [params.orders];
      } else {
        params.orders = ["update_time$2"];
      }
      if (params.textbookId) {
        params.textbookIds = [params.textbookId];
        delete params.textbookId;
      }
      if (params.courseId) {
        params.courseIds = [params.courseId];
        delete params.courseId;
      }
      if (params.gradeIds) {
        params.gradeIds = [params.gradeIds];
      }
      if (params.subjectId) {
        params.subjectIds = [params.subjectId];
        delete params.subjectId;
      }
      if (params.parentTypeId) {
        params.parentTypeIds = [params.parentTypeId];
        delete params.parentTypeId;
      }
      if (params.parentAreaIds) {
        params.parentAreaIds = [params.parentAreaIds];
      }
      if (params.parentCatalogIds) {
        params.parentCatalogIds = [params.parentCatalogIds];
      }
      if (params.parentKPointId) {
        params.parentCatalogIds = [params.parentKPointId];
        delete params.parentKPointId;
      }
      if (params.parentScenarioId) {
        params.parentScenarioIds = [params.parentScenarioId];
        delete params.parentScenarioId;
      }
      // 是否是套卷类型
      if (albumType) {
        params.albumTypeIds = [albumType];
      }
      delete params.softType;
      try {
        // 资料列表
        let data = await getAfterAlbumList({ ...params });
        if (data.code === 200) {
          this.documentList = data.result.list || [];
          this.documentCount = data.result.totalCount || 0;
          this.totalPages = data.result.totalPages || 0;
          this.keyArray = data.result.keyWords || [];
          this.totalCount = data.result.totalCount || 0;
        }
      } catch (error) {
        console.error(error);
      }
      this.isLoading = false;
    },
    // 切换资料的类型
    getResourcesByType(softType) {
      // console.log("获取资料", softType);
      this.currentSoftType = softType;
      // 翻页如果当前有推荐列表
      if (this.currentSoftType === 1) {
        // debugger
        this.getDocumentList();
      } else if (this.currentSoftType === 2) {
        this.getAlbumList();
      }
    },
    // 搜索功能
    search() {
      // console.log("catalogType", this.catalogType);
      let query = this.constructQuery({
        [this.catalogType]: true,
        isCategory: true,
        isScene: true,
        isRange: true,
        isOption: true,
        isFilteDropdown: true,
        isFileType: true,
        isOrder: true,
        isArea: true,
        isGrade: true,
        isTerm: true,
        isTree: true,
        isYearRange: true,
        isUpdateStatus: true,
        isExperimentForm: true,
        isScsyCatalog: true,
        isSciCatalog: true,
      });
      if (this.keywords) {
        query.title = this.keywords;
      }
      // 更新路由的query,
      this.updateQuery(query, isRouteQueryReset);
    },
  },
};
